import { createRoute } from "@tanstack/react-router";
import { authenticatedRoute } from './AuthenticatedView.route';
import { getReviewsInfiniteQuery } from '../api/reviewsApi';
import { Landing } from './Landing.page';
import { DEFAULT_REVIEWS_QUERY_PARAMS } from './components/ReviewsList';
import { FullPageLoader } from '../components/FullPageLoader';

export const landingRoute = createRoute({
    getParentRoute: () => authenticatedRoute,
    path: "dashboard",
    loader: ({ context }) => {
        return context.queryClient.prefetchInfiniteQuery(getReviewsInfiniteQuery(DEFAULT_REVIEWS_QUERY_PARAMS));
    },
    component: Landing,
    pendingComponent:  () => <FullPageLoader />,
});
